<template>
  <div>
        <b-row class="justify-content-start">
        <spinner v-if="activateSpinner"></spinner>
        <div v-else class="min-w-100">

          <div v-if="isReport" class="body">
              <!-- RESULTS -->
              <div>
                <div class="font-weight-bold">
                  <i class="icon fa fa-file" style="margin-right:15px;"/>
                  <span>{{ $t('filter.nameFile') + ' : ' }}</span>
                  <span>{{ fileName? fileName : 'test.csv' }}</span>
                </div>
                <div class="my-2 py-2 line-success">
                  <i class="icon fa fa-check" style="margin-right:15px;"/>
                  <span>{{ results.ACCP }} {{$t("company.fileLineAproove")}}</span>
                </div>
                <div class="my-2 py-2 line-update">
                  <i class="fa-solid fa-envelope-dot" style="margin-right:15px;"/>
                  <span>{{ results.UPDT }} {{$t("company.fileLineUpdated")}}</span>
                </div>
                <div class="my-2 py-2 line-warning">
                  <i class="icon fa fa-pencil" style="margin-right:15px;"/>
                  <span>{{ results.EXST }} {{$t("company.fileLineAlreadyExist")}}</span>
                </div>
                <div class="my-2 py-2 line-error">
                  <i class="icon fa fa-times" style="margin-right:15px;"/>
                  <span>{{ results.RFSL }} {{$t("company.fileLineReject")}}</span>
                </div>
              </div>
          </div>
          <!-- DOWNLOAD BULK MANDATE TEMPLATE -->
          <div v-if="!isReport" class="d-flex justify-content-end mt-5">
            <b-col class="text-left">
              <span
                class="download-template-link"
                role="button"
                @click.stop="downloadMandateBulkTemplate"
              >
                <i class="icon fa fa-download mr-2"></i>
                {{$t("mandate.import_template")}}
              </span>
              <button
                :id="'mandate-template-info-' + randomId"
                type="button"
                class="template-info-button"
                :aria-label="$t('mandate.template_help_title')"
                @click.stop
              >
                <i class="fa fa-info-circle" aria-hidden="true"></i>
              </button>
              <b-popover
                :target="'mandate-template-info-' + randomId"
                triggers="hover click"
                placement="auto"
                boundary="viewport"
                custom-class="mandate-template-popover"
              >
                <template #title>{{ $t('mandate.template_help_title') }}</template>
                <div class="template-help-content">
                  <div v-for="field in templateFields" :key="field" class="template-help-row">
                    <strong>{{ field }}</strong>
                    <span>{{ $t('mandate.template_fields.' + field) }}</span>
                  </div>
                </div>
              </b-popover>
            </b-col>
          </div>
          <div class="d-flex mt-5 justify-content-end">
            <b-col id="btnFakeUpload" class="inline-flex" v-if="!isReport">
              <label class="fake-import-button" for="image_uploads">{{ fileName ? $t("company.fileReplace") : $t('company.fileChoose')}}</label>
              <!--<label class="font-weight-bold fileSelected">{{$t("company.fileSelect")}}</label>-->
              <label v-if="!fileName" for="image_uploads">{{$t("company.fileNone")}}</label>
              <label v-else for="image_uploads">{{ fileName }}</label>
              <input type="file" :key="hiddenButtonKey"
              id="image_uploads"
              ref="file"
              accept=".csv" multiple="" class="opacity-0"
              @change="handleFileUpload()"/>
            </b-col>
              <!-- DOWNLOAD REPORT -->
            <div class="download" v-if="isReport">
              <div class="btn btn-primary">
                <a @click="downloadReport">
                  <i class="icon fa fa-download"/><span class="download-report-text">{{$t("company.fileDownloadReport")}}</span>
                </a>
              </div>
            </div>
            <div class="mb-5 col-lg-2 col-xl-2 col-4">
              <button
                type="button"
                class="btn btn-secondary"
                @click="cancel">
                {{ isReport ? 'OK' : $t("company.fileCancel") }}
              </button>
            </div>
            <div class="mb-5 col-lg-2 col-xl-2 col-4" v-if="!isReport">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="fileContent === '' || fileName === '' || showLoader"
                @click="send">
                {{$t("company.fileSend")}}
              </button>
            </div>
          </div>
        </div>
        </b-row>
      </div>
</template>

<script>
import moment from 'moment'
//import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage,reloadPage} from '@/helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'
import {downloadFile} from '@/helpers/download'
import {verifyMandatoryValues, checkErrorFlag} from '@/helpers/validator'



export default {
  name: 'CompaniesImport',
  components: {
    //'cm-pagination': Pagination,
    'spinner': Spinner,
    'page-outline': PageOutline
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  computed: {
    listTitle () {
      return this.$t('Webheader.company')
    },
    canUserImportCompagny() {
      return this.$engine.rights.rightIs('company_import', true) || this.$engine.rights.rightIs('company_import', true)
    }
  },
  data () {
    return {
      templateFields: ['id_contract', 'type_transaction', 'dbtr_name', 'dbtr_iban', 'dbtr_email', 'schema_code', 'dbtr_addr', 'dbtr_city', 'dbtr_country', 'dbtr_tel', 'sign_mode'],
      activateSpinner: false,
      active: '',
      identifier: '',
      filterBy: '',
      name: '',
      CompaniesList: [],
      idCompany: '',
      hiddenButtonKey: false,
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      displayFilter: false,
      hasDefaultFilter: false,
      timer: '',
      fileName: '',
      fileNameError: false,
      file: undefined,
      importName: '',
      importNameError: false,
      isReport: false,
      reportData: '',
      fileContent: '',
      results: {},
      showLoader: false
    }
  },
  created () {
    let that = this
  },
  mounted () {

    this.$$('.infinite-scroll-preloader').remove()
    this.$bus.emit('set-small-panel')
    //let defaultFilter = this.$engine.company.getDefaultFilter()
    //this.setDefaultFilter(defaultFilter)
  },
  beforeDestroy () {
    let that = this
    that.$engine.company.cleanFilterCondition()
  },
  methods: {
    cancel () {
      this.fileName = false
      this.isReport = false
      this.hiddenButtonKey = !this.hiddenButtonKey
    },
    computeICSFrom(countryFullName, nationalIdRaw, businessCode = 'ZZZ') {
      const cc = this.countryNameToISO2(countryFullName)
      if (!cc) return ''

      // 1) Normaliser l'identifiant national (FR → SIREN, etc.)
      const { nid } = this.normalizeNationalId(cc, nationalIdRaw)
      if (!nid) return ''

      // 2) On force MINIMUM 15 CHIFFRES après ZZZ
      //    - On ne garde que les chiffres
      //    - On pad à gauche avec des '0' jusqu'à 15
      const nidDigits = String(nid).replace(/\D/g, '')
      const nidPadded15 = nidDigits.padStart(15, '0')

      // 3) Business code (ex: 'ZZZ')
      const b = (businessCode || 'ZZZ').toUpperCase()
      if (!/^[A-Z0-9]{3}$/.test(b)) return ''

      // 4) Calcul des 2 digits de contrôle (mod 97) sur: b + nidPadded15 + cc + "00"
      const rearr = `${b}${nidPadded15}${cc}00`
      const numeric = this.lettersToDigits(rearr)
      const remainder = this.mod97(numeric)
      const check = String(98 - remainder).padStart(2, '0')

      // 5) Retourne ICS: CC + check + b + nidPadded15
      return `${cc}${check}${b}${nidPadded15}`
    },
    countryNameToISO2(name) {
      if (!name) return ''
      const n = name.trim().toLowerCase()
      const map = {
        'france': 'FR',
        'allemagne': 'DE', 'germany': 'DE',
        'italie': 'IT', 'italy': 'IT',
        'espagne': 'ES', 'spain': 'ES',
        'belgique': 'BE', 'belgium': 'BE',
        'luxembourg': 'LU',
        'pays-bas': 'NL', 'pays bas': 'NL', 'netherlands': 'NL',
        'portugal': 'PT',
        'irlande': 'IE', 'ireland': 'IE',
        'autriche': 'AT', 'austria': 'AT',
        'finlande': 'FI', 'finland': 'FI',
        'suède': 'SE', 'suede': 'SE', 'sweden': 'SE',
        'danemark': 'DK', 'denmark': 'DK',
        'norvège': 'NO', 'norvege': 'NO', 'norway': 'NO',
        'islande': 'IS', 'iceland': 'IS',
        'suisse': 'CH', 'switzerland': 'CH',
        'pologne': 'PL', 'poland': 'PL',
        'république tchèque': 'CZ', 'republique tcheque': 'CZ', 'czechia': 'CZ', 'czech republic': 'CZ',
        'slovaquie': 'SK', 'slovakia': 'SK',
        'slovénie': 'SI', 'slovenie': 'SI', 'slovenia': 'SI',
        'croatie': 'HR', 'croatia': 'HR',
        'estonie': 'EE', 'estonia': 'EE',
        'lettonie': 'LV', 'latvia': 'LV',
        'lituanie': 'LT', 'lithuania': 'LT',
        'malte': 'MT', 'malta': 'MT',
        'chypre': 'CY', 'cyprus': 'CY',
        'roumanie': 'RO', 'romania': 'RO',
        'bulgarie': 'BG', 'bulgaria': 'BG',
        'hongrie': 'HU', 'hungary': 'HU',
        'grèce': 'GR', 'grece': 'GR', 'greece': 'GR'
      }
      return map[n] || ''
    },

    normalizeNationalId(cc, raw) {
      if (!raw) return { nid: '', note: '' }
      let nid = String(raw).replace(/\s+/g, '')
      let note = ''

      if (cc === 'FR') {
        const digits = nid.replace(/\D/g, '')
        if (/^\d{14}$/.test(digits)) {
          nid = digits.slice(0, 9) // SIRET → SIREN
          note = `SIRET détecté, SIREN utilisé: ${nid}`
        } else if (/^\d{9}$/.test(digits)) {
          nid = digits
          note = `SIREN utilisé: ${nid}`
        } else {
          return { nid: '', note: 'Identifiant FR invalide (attendu SIREN 9 ou SIRET 14)' }
        }
      } else {
        nid = nid.toUpperCase()
        if (/[^A-Z0-9]/.test(nid)) return { nid: '', note: 'Identifiant national non alphanumérique' }
      }
      return { nid, note }
    },



    lettersToDigits(s) {
      let out = ''
      for (let i = 0; i < s.length; i++) {
        const code = s.charCodeAt(i)
        if (code >= 48 && code <= 57) out += s[i]
        else if (code >= 65 && code <= 90) out += (code - 55)
      }
      return out
    },

    mod97(numStr) {
      let rem = 0
      for (let i = 0; i < numStr.length; i += 7) {
        const part = String(rem) + numStr.substr(i, 7)
        rem = parseInt(part, 10) % 97
      }
      return rem
    },
    send() {
      const that = this;

      let flagsList = { fileName: true }
      const mandatoryValues = ['fileName']
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      if (checkErrorFlag(flagsList)) return

      this.showLoader = true

      const paramsGet = {}
      let index = 0
      this.$engine.Mandat.getMandat(paramsGet)
        .then((resp) => {
          const payload = resp?.data ?? {}
          const rawList = Array.isArray(payload.Mandates) ? payload.Mandates : []
          const selected = rawList[index] || {}

          const crtInfo = payload.crt_info || {}
          // Normalise toutes les clés : " cdtr_country" -> "cdtr_country"
          const crt = Object.keys(crtInfo).reduce((acc, k) => {
            acc[k.trim()] = crtInfo[k]
            return acc
          }, {})

          const crtCity = crt.cdtr_city ?? ''
          const crtAddr = crt.cdtr_address ?? crt.cdtr_addr ?? ''
          const crtName = crt.cdtr_name ?? ''
          const countryFullName = crt.cdtr_country ?? ''
          const creditorIdentifier = crt.cdtr_identifier ?? ''

          // Affectation des valeurs
          this.cdtr_addrss = crtAddr || selected.cdtr_addr || this.cdtr_addrss
          this.cdtr_city = crtCity || selected.cdtr_city || this.cdtr_city
          this.cdtr_name = crtName || selected.cdtr_name || this.cdtr_name
          this.cdtr_ctry = countryFullName || this.cdtr_ctry

          // Calcul ICS → cdtr_id
          const computedICS = this.computeICSFrom(countryFullName, creditorIdentifier, 'ZZZ')
          this.cdtr_id = computedICS || selected.cdtr_id || this.cdtr_id

          this.$f7?.pullToRefreshDone?.()
          this.activateSpinner = false
        })
        .catch((error) => {
          this.activateSpinner = false
        })
        .finally(() => {
          // Une fois getMandat terminé (succès ou erreur), on lance addMandatBulk
          const paramsAdd = {
            Data: this.fileContent,
            CodeLanguage: this.$i18n.locale.toUpperCase(),
            FileName: this.fileName,
            cdtr_id: this.cdtr_id,
            cdtr_name: this.cdtr_name,
            cdtr_addr: this.cdtr_addrss,
            cdtr_city: this.cdtr_city,
            cdtr_ctry: this.cdtr_ctry
          }
          this.$engine.Mandat.addMandatBulk(paramsAdd)
            .then((resp) => {
              that.$f7.modal({
                title: that.$t('mandate.file_imported'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: () => {},
                  },
                ],
              });
              loadPage(that, { url: '/mandatpage/bulk' })
            })
            .catch((err) => {
              let title = that.$t('error')
              let description = that.$t('errorHappend')

              if (err?.response?.statusText && err?.response?.data?.errorDescription) {
                title = err.response.statusText
                description = err.response.data.errorDescription
              }

              this.$f7.alert(description, title)
              that.showLoader = false

              const status = err?.response?.status
              if (status >= 410 && status <= 422) {
                this.$emit('close')
                that.$bus.$emit('logout')
              }
            })
        })
    },
    downloadMandateBulkTemplate () {
      const headers = [
        'id_contract',
        'type_transaction',
        'dbtr_name',
        'dbtr_iban',
        'dbtr_email',
        'schema_code',
        'dbtr_addr',
        'dbtr_city',
        'dbtr_country',
        'dbtr_tel',
        'sign_mode'

      ]
      const data = headers.join(';') + '\r\n'
      const linkSource =
        'data:text/csv;charset:utf-8;base64,' +
        btoa(
          unescape(
            encodeURIComponent(data)
          )
        )

      const downloadLink =
        document.createElement('a')

      const fileName =
        'mandate_bulk_template.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName

      downloadLink.click()
    },
    downloadReport () {
      if (this.reportData) {
        downloadFile(moment().format('DDMMYYYYhhmmss') + '_rapport.csv', this.reportData)
      } else {
        // this.$bus.$emit('sm-notif', {title: that.$t('error'), description: that.$t('noFile'), error: true})
        this.$f7.alert(that.$t('noFile'), that.$t('error'))
      }
    },
    handleFileUpload () {
      let that = this
      if (this.$refs.file && this.$refs.file.files && this.$refs.file.files.length) {
        this.file = this.$refs.file.files[0]
        this.fileName = this.file.name
        let fd = new FileReader()
        fd.onload = (event) => {
          let fileData = event.target.result
          if (fileData) {
            try {
              that.fileContent = btoa(fileData)
              if (that.fileContent.length > 5800000) {
                this.$refs.file.value = ''
                that.fileContent = ''
                // that.$bus.$emit('sm-notif', {title: that.$t('error'), description: that.$t('toobigFile'), error: true})
                this.$f7.alert(that.$t('toobigFile'), that.$t('error'))
                return
              }
            } catch (e) {
              let fd2 = new FileReader()
              fd2.onload = (event) => {
                let fileData = event.target.result
                if (fileData) {
                  try {
                    that.fileContent = btoa(fileData)
                    if (that.fileContent.length > 5800000) {
                      that.$refs.file.value = ''
                      that.fileContent = ''
                      that.$bus.$emit('sm-notif', {title: 'Erreur', description: 'Fichier d\'import trop volumineux.', error: true})
                      this.$f7.alert('Fichier d\'import trop volumineux.', that.$t('error'))
                      return
                    }
                  } catch (e2) {
                    that.$refs.file.value = ''
                    that.fileContent = ''
                    that.$bus.$emit('sm-notif', {title: 'Erreur', description: 'Erreur dans le fichier d\'import.', error: true})
                    this.$f7.alert('Erreur dans le fichier d\'import.', that.$t('error'))
                  }
                }
              }
              fd2.readAsText(this.file, 'windows-1252')
            }
          }
        }
        fd.readAsText(this.file)
      }
    }
  }
}
</script>
<style scoped>
.template-info-button {
  margin-left: 10px;
  padding: 2px 5px;
  border: 0;
  background: transparent;
  color: var(--actionTextColorBlue, #007bff);
  cursor: pointer;
  font-size: 17px;
  vertical-align: middle;
}
.template-info-button:focus-visible { outline: 2px solid currentColor; border-radius: 50%; }
.template-help-content { max-height: 340px; overflow-y: auto; }
.template-help-row { display: flex; flex-direction: column; margin-bottom: 9px; }
.template-help-row strong { font-size: 12px; }
.template-help-row span { font-size: 12px; }
/* BootstrapVue mounts popovers outside the component: use a global stylesheet
   for .mandate-template-popover { max-width: 380px; } if needed. */

.readable-filename {
  background-color: #e6e6e6;
}

.fake-import-button{
  cursor:pointer;
  background-color: #f5f3f3;
  border: 2px solid var(--borderButtonColorBlue);
  color: var(--actionTextColorBlue);
  min-width: 250px;
  max-width: -webkit-fill-available;
  padding:5px;
  margin-right:5px;
  min-height:30px;
  border-radius: 10px;
}

.fileSelected{
  width:auto;
}

.line-success {
  background-color: #dff0d8;
  color: black;
  font-weight: bold;
  padding-left:4px;
}

.line-update {
  background-color: #add2dc;
  color: black;
  font-weight: bold;
  padding-left:4px;
}

.line-warning {
  background-color: #fcf8e3;
  color: black;
  font-weight: bold;
  padding-left:4px;
}

.line-error {
  background-color: #ff9191;
  color: black;
  font-weight: bold;
  padding-left:4px;
}

.download-report-text {
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  min-height:30px;
  Line-height:1;
  vertical-align: middle;
  padding:2px;
}

.download{
  min-height:30px;
  Line-height:1;
  vertical-align: middle;
  width:250px;
}
.download .btn.btn-primary {
    background: var(--actionButtonColorBlue);
    border: 2px solid var(--borderButtonColorBlue);
    color: var(--actionTextColorWhite);
    width: inherit;
    max-width: -webkit-fill-available;
    Line-height:1;
    vertical-align: middle;
    padding-top: 8px !important;
}

.download .btn a{
  min-height:30px;
  Line-height:1;
  vertical-align: middle;
  width:inherit;

}

.download-report-text {
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  min-height:30px;
  Line-height:1;
  vertical-align: middle;
  padding:2px;
}
.download-template-link {
  cursor: pointer;
  color: var(--actionTextColorBlue);
  font-weight: 500;
  text-decoration: underline;
}

.download-template-link:hover {
  text-decoration: none;
}
</style>
